import React, { useState, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import {
    copyToClipboard,
    generateHiddenColumns,
    hasPermission,
    assetsPermissionOptions,
    assetsUseManageOptions,
    fetchAPIData,
    cleanObject,
    getCompanyId,
    getToken,
    getUser,
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Table, { renderCellExpand } from '../../components/Table/Table';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import EnvisionDocumentTypePropertiesPanel from './EnvisionDocumentTypePropertiesPanel';
import Ajv from "ajv";
import axios from 'axios';


const envisionDocumentTypeSchemaRequired = require("../../json/envisionDocumentTypeSchema.json").create.required;
const envisionDocumentTypeSchemaOptional = require("../../json/envisionDocumentTypeSchema.json").create.optional;

const ajv = new Ajv({ strict: false });

const EnvisionDocumentTypesTabPanel = ({ setNotify, enVisionDocumentType, setenVisionDocumentType }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [reload, setReload] = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);


    useEffect(() => {
        if (enVisionDocumentType) {
            createEnvisionDocumentTypesData();
        }
    }, [enVisionDocumentType]);


    // API URL is dynamic in that COMPANY_ID is replaced
    const apiURL = '/api/companies/%COMPANY_ID%/evDocumentTypes/%NAME%';
    const formId = 'EnvisionDocumentTypeDialog';
    const saveButtonText = "Save enVision Document Type";


    const fieldData = [
        'name'
    ];

    const filterOperators = [
        {
            label: 'EQUALS(=)',
            value: '='
        }
    ];

    const hasAssetsUseManage = hasPermission(permissions, assetsUseManageOptions);


    const columns = [
        {
            field: 'companyId',
            hideable: false,
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'documentTypeId',
            hideable: false,
            headerName: 'Document Type ID',
            minWidth: 325,
            maxWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '275px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document Type ID" onClick={(event) => copyToClipboard(event, params.row.documentTypeId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'name',
            hideable: false,
            headerName: 'Name',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '110px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy name" onClick={(event) => copyToClipboard(event, params.row.name)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'description',
            hideable: false,
            headerName: 'Description',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'label',
            hideable: false,
            headerName: 'Label',
            minWidth: 150,
            maxWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'attributes',
            hideable: false,
            headerName: 'Attributes',
            minWidth: 675,
            // maxWidth: 680,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                        {params.value && (
                            <div style={{ flexDirection: 'column', display: 'inline-block', textAlign: 'left' }}>
                                <table style={{ width: '525px', padding: '10px' }}>

                                    <tr>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Name</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Type</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Encrypted</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Category</th>
                                        <th style={{ border: '1px solid #dddddd', textAlign: 'left' }}>Label</th>
                                    </tr>
                                    {params.value && params.value.map((attr, index) => {
                                        return (

                                            <tr key={index}>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.name}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.type}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.encrypted ? 'true' : 'false'}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.category}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left' }}>{attr.label}</td>
                                            </tr>

                                        );
                                    })}
                                </table>
                            </div>
                        )}
                    </>
                );
            }
        },

        {
            field: 'createdDate',
            headerName: 'Created Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'modifiedDate',
            headerName: 'Modified Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },


    ];

    const getColumns = () => {
        return (hasAssetsUseManage && columns) || columns.filter(obj => { return obj.field !== "actions" });
    };

    const [documentTypes, setDocumentTypes] = usePersistentStorage("enVisionDocumentTypes", []);

    useEffect(() => {
        // check if localstorge had data for the current tab
        setApiData(documentTypes);
    }, []);

    const fetchData = async (apiURL2, qparams) => {
        // console.log('inside fetch customer data:', qparams);
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating table data: ", data);
                setApiData(data);
                setDocumentTypes(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load envision document type data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });
    };

    const handleJsonChange = (formData) => {
        setRowJsonData(formData);
    };

    const handleClose = () => {
        setOpen(false);

        setenVisionDocumentType(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    }

    const createEnvisionDocumentTypesData = () => {
        let rowData = {};
        const JsonData = rowData;

        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };



    const validateSchema = (documentTypeSchema, data) => {
        // console.log('got json schema', documentTypeSchema);
        const validate = ajv.compile(documentTypeSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }


    const saveDocumentTypeData = (formData) => {

        // console.log('called save document type:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        /*
        if (mode === 'edit') {
            if (validateSchema(documentTypeSchemaUpdateRequired, cleanedObj)) {
                if (validateSchema(documentTypeSchemaUpdateOptional, cleanedObj)) {
                    // console.log('update core document type schema validated successfully..');
                    updateDocumentType(cleanedObj);
                }
                else {
                    console.log('update core document type schema validation failed for optional params..');
                    let message = `Update core document type schema validation failed for optional parameters`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Schema Validation Failure',
                        message: message,
                        severity: 'error'
                    });
                }
            } else {
                console.log('update core document type schema validation failed..');
                let message = `Update core document type schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }
        }
        */

        if (mode === 'create') {
            if (validateSchema(envisionDocumentTypeSchemaRequired, cleanedObj)) {
                if (validateSchema(envisionDocumentTypeSchemaOptional, cleanedObj)) {
                    // console.log('create schema validated successfully..');
                    createDocumentType(cleanedObj);
                }
                else {
                    console.log('create envision document type schema validation failed for optional params..');
                    let message = `Create envision document type schema validation failed for optional parameters`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Schema Validation Failure',
                        message: message,
                        severity: 'error'
                    });
                }
            }
            else {
                console.log('create schema validation failed..');
                let message = `Create envision document type schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setenVisionDocumentType(false);
        }
    }


    const createDocumentType = (data) => {
        try {
            // console.log('inside document type create api..');

            // TODO: Need to verify and test the API endpoint - TEP-89
            let createUrl = `/api/companies/${data.companyId}/documentTypes`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Created envision document type [${response.data.name}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        //setApiData([]);
                        setReload(true);

                        // console.log('got response from core document type create:', response);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to create envision document type data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in create envision document type api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
        }
    }

    const getSchema = (mode) => {
        if (mode === 'create') {
            return [envisionDocumentTypeSchemaRequired, envisionDocumentTypeSchemaOptional];
            /*
        } else if (mode === 'edit') {
            return [documentTypeSchemaUpdateRequired, documentTypeSchemaUpdateOptional];
            */
        } else {
            // in view mode should be readonly so just choose create schema.
            // may want to create a view schema
            return [envisionDocumentTypeSchemaRequired, envisionDocumentTypeSchemaOptional];
        }
    };



    return (
        <>

            <div id="enVisionDocumentTypefilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={assetsPermissionOptions} fields={fieldData} filterOperators={filterOperators} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={true} includeLimit={false} includeTotalDisplay={false} includeSort={false} tabName={'envisionDocumentTypesTab'} />
            </div>

            <Divider />

            <div id="enVisionDocumentTypeTableContainer">
                <div >
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveDocumentTypeData)}
                title="enVision Document Type Information"
                propertiesTabContent={<EnvisionDocumentTypePropertiesPanel formId={formId}
                    documentTypeSchemaRequired={getSchema(mode)[0]}
                    documentTypeSchemaOptional={getSchema(mode)[1]}
                    saveDocumentTypeData={saveDocumentTypeData}
                    formData={rowJsonData} handleFormChange={handleFormChange}
                    readOnly={readOnly} />
                }
                jsonDataName="document types"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />
        </>
    );
}

export default EnvisionDocumentTypesTabPanel;